<template>
  <div>
    <h3>Translational Teams</h3>
    <teams-list :translationalTeams="translationalTeams"></teams-list>
  </div>
</template>

<script>
import TeamsList from "../../components/translationalteams/teams-list";
import translationalTeamsApi from "../../api/translationalTeams";

export default {
  data() {
    return {
      translationalTeams: []
    };
  },

  components: {
    "teams-list": TeamsList
  },

  created() {
    var that = this;
    translationalTeamsApi
      .getTranslationalTeams()
      .then(function(response) {
        that.translationalTeams = response.data;
      })
      .catch(function(error) {
        console.log(error);
      });
  }
};
</script>

<style scoped>
</style>
